module.exports = __webpack_public_path__ + "img/Kibe18.dc07792b.jpg";